// extracted by mini-css-extract-plugin
export default {"btn":"AddBtn_btn__vvYjN"};